module.exports = __webpack_public_path__ + "img/04.056d8ff3.jpg";